import { getTextField } from '@lender/utils';

import { DOC_FIELD_TYPES } from 'constants/documentFieldTypes';
import { EXPRESSION_TYPES } from 'constants/parser';

export const getCalculationField = (fieldType, expressionType) => {
  return getTextField().test({
    name: 'calculation-field',
    message: `'Field type' and 'Expression return type' should match`,
    test() {
      if (expressionType) {
        switch (fieldType) {
          case DOC_FIELD_TYPES.DATE:
          case DOC_FIELD_TYPES.BOOL:
            return fieldType.toLowerCase() === expressionType;

          case DOC_FIELD_TYPES.TEXT:
            return expressionType === EXPRESSION_TYPES.STRING;

          case DOC_FIELD_TYPES.INTEGER:
          case DOC_FIELD_TYPES.DOUBLE:
            return [EXPRESSION_TYPES.INT, EXPRESSION_TYPES.DECIMAL].includes(expressionType);

          default:
            return false;
        }
      }

      return true;
    },
  });
};
